import { Pressable } from "react-native";
import styled from "styled-components/native";
import { useRouter } from "expo-router";
import { useDev } from "@/contexts/DevContext";
import { useAuth } from "@/contexts/AuthContext";
import { colors, font } from "@/lib/theme";

const LinkText = styled.Text`
  font-size: 12px;
  color: ${colors.inkMuted};
  font-weight: ${font.medium};
  text-align: center;
  margin-top: 16px;
`;

export function DevSwitcherLink() {
  const router = useRouter();
  const { isDevMode } = useDev();
  const { user } = useAuth();

  if (!isDevMode) return null;

  const isTestUser = user?.uid?.startsWith("test-player-");

  return (
    <Pressable onPress={() => router.push("/(app)/dev-switcher")}>
      <LinkText>
        {isTestUser
          ? `🔀 Test user: ${user?.displayName || user?.uid} · Switch`
          : "🔀 Dev: Switch user"
        }
      </LinkText>
    </Pressable>
  );
}

export default function DevSwitcher() {
  return null;
}
